/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getUsageAreas } from '../fn/usage-statistics/get-usage-areas';
import { GetUsageAreas$Params } from '../fn/usage-statistics/get-usage-areas';
import { getUsageBotLots } from '../fn/usage-statistics/get-usage-bot-lots';
import { GetUsageBotLots$Params } from '../fn/usage-statistics/get-usage-bot-lots';
import { getUsageBots } from '../fn/usage-statistics/get-usage-bots';
import { GetUsageBots$Params } from '../fn/usage-statistics/get-usage-bots';
import { getUsageBulkCallers } from '../fn/usage-statistics/get-usage-bulk-callers';
import { GetUsageBulkCallers$Params } from '../fn/usage-statistics/get-usage-bulk-callers';
import { getUsageCalls } from '../fn/usage-statistics/get-usage-calls';
import { GetUsageCalls$Params } from '../fn/usage-statistics/get-usage-calls';
import { getUsageFilters } from '../fn/usage-statistics/get-usage-filters';
import { GetUsageFilters$Params } from '../fn/usage-statistics/get-usage-filters';
import { getUsageLoadAverage } from '../fn/usage-statistics/get-usage-load-average';
import { GetUsageLoadAverage$Params } from '../fn/usage-statistics/get-usage-load-average';
import { getUsageLoadSeries } from '../fn/usage-statistics/get-usage-load-series';
import { GetUsageLoadSeries$Params } from '../fn/usage-statistics/get-usage-load-series';
import { getUsageLots } from '../fn/usage-statistics/get-usage-lots';
import { GetUsageLots$Params } from '../fn/usage-statistics/get-usage-lots';
import { getUsageTickerConnectionsSeries } from '../fn/usage-statistics/get-usage-ticker-connections-series';
import { GetUsageTickerConnectionsSeries$Params } from '../fn/usage-statistics/get-usage-ticker-connections-series';
import { getUsageTopLandings } from '../fn/usage-statistics/get-usage-top-landings';
import { GetUsageTopLandings$Params } from '../fn/usage-statistics/get-usage-top-landings';
import { UsageAreasDto } from '../models/usage-areas-dto';
import { UsageBotCallsDto } from '../models/usage-bot-calls-dto';
import { UsageBotLotsDto } from '../models/usage-bot-lots-dto';
import { UsageBulkCallersDto } from '../models/usage-bulk-callers-dto';
import { UsageCallsDto } from '../models/usage-calls-dto';
import { UsageFiltersDto } from '../models/usage-filters-dto';
import { UsageLoadDto } from '../models/usage-load-dto';
import { UsageLoadSeriesDto } from '../models/usage-load-series-dto';
import { UsageLotsDto } from '../models/usage-lots-dto';
import { UsageTickerConnectionsSeriesDto } from '../models/usage-ticker-connections-series-dto';
import { UsageTopLandingsDto } from '../models/usage-top-landings-dto';

@Injectable({ providedIn: 'root' })
export class GeneratedUsageStatisticsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getUsageCalls()` */
  static readonly GetUsageCallsPath = '/api/usage-statistics/calls';

  /**
   * Gets the lot search calls of a period by day, kind, user agent and visitor class.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUsageCalls()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUsageCalls$Response(params?: GetUsageCalls$Params, context?: HttpContext): Observable<StrictHttpResponse<UsageCallsDto>> {
    return getUsageCalls(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the lot search calls of a period by day, kind, user agent and visitor class.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUsageCalls$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUsageCalls(params?: GetUsageCalls$Params, context?: HttpContext): Observable<UsageCallsDto> {
    return this.getUsageCalls$Response(params, context).pipe(
      map((r: StrictHttpResponse<UsageCallsDto>): UsageCallsDto => r.body)
    );
  }

  /** Path part for operation `getUsageLoadAverage()` */
  static readonly GetUsageLoadAveragePath = '/api/usage-statistics/load/average';

  /**
   * Gets the average lot search calls, or the lots they delivered, per 10-minute slot over a period, optionally of one weekday.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUsageLoadAverage()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUsageLoadAverage$Response(params?: GetUsageLoadAverage$Params, context?: HttpContext): Observable<StrictHttpResponse<UsageLoadDto>> {
    return getUsageLoadAverage(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the average lot search calls, or the lots they delivered, per 10-minute slot over a period, optionally of one weekday.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUsageLoadAverage$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUsageLoadAverage(params?: GetUsageLoadAverage$Params, context?: HttpContext): Observable<UsageLoadDto> {
    return this.getUsageLoadAverage$Response(params, context).pipe(
      map((r: StrictHttpResponse<UsageLoadDto>): UsageLoadDto => r.body)
    );
  }

  /** Path part for operation `getUsageLoadSeries()` */
  static readonly GetUsageLoadSeriesPath = '/api/usage-statistics/load/series';

  /**
   * Gets the lot search calls, or the lots they delivered, of a period in steps of the given minutes, day after day, at most 500 values.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUsageLoadSeries()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUsageLoadSeries$Response(params?: GetUsageLoadSeries$Params, context?: HttpContext): Observable<StrictHttpResponse<UsageLoadSeriesDto>> {
    return getUsageLoadSeries(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the lot search calls, or the lots they delivered, of a period in steps of the given minutes, day after day, at most 500 values.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUsageLoadSeries$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUsageLoadSeries(params?: GetUsageLoadSeries$Params, context?: HttpContext): Observable<UsageLoadSeriesDto> {
    return this.getUsageLoadSeries$Response(params, context).pipe(
      map((r: StrictHttpResponse<UsageLoadSeriesDto>): UsageLoadSeriesDto => r.body)
    );
  }

  /** Path part for operation `getUsageTickerConnectionsSeries()` */
  static readonly GetUsageTickerConnectionsSeriesPath = '/api/usage-statistics/ticker-connections/series';

  /**
   * Gets the highest number of open connections to the customer website's auction ticker of a period in steps of the given minutes, day after day, at most 500 values.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUsageTickerConnectionsSeries()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUsageTickerConnectionsSeries$Response(params?: GetUsageTickerConnectionsSeries$Params, context?: HttpContext): Observable<StrictHttpResponse<UsageTickerConnectionsSeriesDto>> {
    return getUsageTickerConnectionsSeries(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the highest number of open connections to the customer website's auction ticker of a period in steps of the given minutes, day after day, at most 500 values.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUsageTickerConnectionsSeries$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUsageTickerConnectionsSeries(params?: GetUsageTickerConnectionsSeries$Params, context?: HttpContext): Observable<UsageTickerConnectionsSeriesDto> {
    return this.getUsageTickerConnectionsSeries$Response(params, context).pipe(
      map((r: StrictHttpResponse<UsageTickerConnectionsSeriesDto>): UsageTickerConnectionsSeriesDto => r.body)
    );
  }

  /** Path part for operation `getUsageFilters()` */
  static readonly GetUsageFiltersPath = '/api/usage-statistics/filters';

  /**
   * Gets how often each filter value of the lot search was used over a period.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUsageFilters()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUsageFilters$Response(params?: GetUsageFilters$Params, context?: HttpContext): Observable<StrictHttpResponse<UsageFiltersDto>> {
    return getUsageFilters(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets how often each filter value of the lot search was used over a period.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUsageFilters$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUsageFilters(params?: GetUsageFilters$Params, context?: HttpContext): Observable<UsageFiltersDto> {
    return this.getUsageFilters$Response(params, context).pipe(
      map((r: StrictHttpResponse<UsageFiltersDto>): UsageFiltersDto => r.body)
    );
  }

  /** Path part for operation `getUsageAreas()` */
  static readonly GetUsageAreasPath = '/api/usage-statistics/areas';

  /**
   * Gets the lot search calls per auction, catalog and part over a period, with the page numbers requested there at the page sizes 20 and 100.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUsageAreas()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUsageAreas$Response(params?: GetUsageAreas$Params, context?: HttpContext): Observable<StrictHttpResponse<UsageAreasDto>> {
    return getUsageAreas(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the lot search calls per auction, catalog and part over a period, with the page numbers requested there at the page sizes 20 and 100.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUsageAreas$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUsageAreas(params?: GetUsageAreas$Params, context?: HttpContext): Observable<UsageAreasDto> {
    return this.getUsageAreas$Response(params, context).pipe(
      map((r: StrictHttpResponse<UsageAreasDto>): UsageAreasDto => r.body)
    );
  }

  /** Path part for operation `getUsageLots()` */
  static readonly GetUsageLotsPath = '/api/usage-statistics/lots';

  /**
   * Gets every lot of a part with its appearances in results and its landings from outside over a period.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUsageLots()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUsageLots$Response(params?: GetUsageLots$Params, context?: HttpContext): Observable<StrictHttpResponse<UsageLotsDto>> {
    return getUsageLots(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets every lot of a part with its appearances in results and its landings from outside over a period.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUsageLots$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUsageLots(params?: GetUsageLots$Params, context?: HttpContext): Observable<UsageLotsDto> {
    return this.getUsageLots$Response(params, context).pipe(
      map((r: StrictHttpResponse<UsageLotsDto>): UsageLotsDto => r.body)
    );
  }

  /** Path part for operation `getUsageTopLandings()` */
  static readonly GetUsageTopLandingsPath = '/api/usage-statistics/landings';

  /**
   * Gets the lots with the most landings from outside over a period, of one part, one auction or all, by the landings of the given visitor classes.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUsageTopLandings()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUsageTopLandings$Response(params?: GetUsageTopLandings$Params, context?: HttpContext): Observable<StrictHttpResponse<UsageTopLandingsDto>> {
    return getUsageTopLandings(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the lots with the most landings from outside over a period, of one part, one auction or all, by the landings of the given visitor classes.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUsageTopLandings$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUsageTopLandings(params?: GetUsageTopLandings$Params, context?: HttpContext): Observable<UsageTopLandingsDto> {
    return this.getUsageTopLandings$Response(params, context).pipe(
      map((r: StrictHttpResponse<UsageTopLandingsDto>): UsageTopLandingsDto => r.body)
    );
  }

  /** Path part for operation `getUsageBots()` */
  static readonly GetUsageBotsPath = '/api/usage-statistics/bots';

  /**
   * Gets the lot search calls of every bot and search engine over a period, by day and kind.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUsageBots()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUsageBots$Response(params?: GetUsageBots$Params, context?: HttpContext): Observable<StrictHttpResponse<UsageBotCallsDto>> {
    return getUsageBots(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the lot search calls of every bot and search engine over a period, by day and kind.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUsageBots$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUsageBots(params?: GetUsageBots$Params, context?: HttpContext): Observable<UsageBotCallsDto> {
    return this.getUsageBots$Response(params, context).pipe(
      map((r: StrictHttpResponse<UsageBotCallsDto>): UsageBotCallsDto => r.body)
    );
  }

  /** Path part for operation `getUsageBotLots()` */
  static readonly GetUsageBotLotsPath = '/api/usage-statistics/bots/lots';

  /**
   * Gets the lots bots and search engines entered most often over a period, of one agent or of all.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUsageBotLots()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUsageBotLots$Response(params?: GetUsageBotLots$Params, context?: HttpContext): Observable<StrictHttpResponse<UsageBotLotsDto>> {
    return getUsageBotLots(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the lots bots and search engines entered most often over a period, of one agent or of all.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUsageBotLots$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUsageBotLots(params?: GetUsageBotLots$Params, context?: HttpContext): Observable<UsageBotLotsDto> {
    return this.getUsageBotLots$Response(params, context).pipe(
      map((r: StrictHttpResponse<UsageBotLotsDto>): UsageBotLotsDto => r.body)
    );
  }

  /** Path part for operation `getUsageBulkCallers()` */
  static readonly GetUsageBulkCallersPath = '/api/usage-statistics/bulk-callers';

  /**
   * Gets the networks and bots that called the lot search more often in a 10-minute slot than their threshold allows.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUsageBulkCallers()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUsageBulkCallers$Response(params?: GetUsageBulkCallers$Params, context?: HttpContext): Observable<StrictHttpResponse<UsageBulkCallersDto>> {
    return getUsageBulkCallers(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the networks and bots that called the lot search more often in a 10-minute slot than their threshold allows.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUsageBulkCallers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUsageBulkCallers(params?: GetUsageBulkCallers$Params, context?: HttpContext): Observable<UsageBulkCallersDto> {
    return this.getUsageBulkCallers$Response(params, context).pipe(
      map((r: StrictHttpResponse<UsageBulkCallersDto>): UsageBulkCallersDto => r.body)
    );
  }

}
